export const PREMIUM_VOICES = [
  {
    id: "coral",
    label: "Clara",
    gender: "Female",
    accent: "British",
    detail: "precise classroom English",
    instructions: "Speak in a clear British English accent with calm, teacher-like pacing."
  },
  {
    id: "nova",
    label: "Mia",
    gender: "Female",
    accent: "American",
    detail: "natural and friendly",
    instructions: "Speak in a natural American English accent with clear pronunciation for language learners."
  },
  {
    id: "shimmer",
    label: "Isla",
    gender: "Female",
    accent: "Australian",
    detail: "bright and expressive",
    instructions: "Speak in a light Australian English accent with careful consonants and natural rhythm."
  },
  {
    id: "ash",
    label: "Arthur",
    gender: "Male",
    accent: "British",
    detail: "steady and clear",
    instructions: "Speak in a clear British English accent with measured pacing and strong articulation."
  },
  {
    id: "onyx",
    label: "James",
    gender: "Male",
    accent: "American",
    detail: "deep and direct",
    instructions: "Speak in a neutral American English accent with confident, easy-to-repeat phrasing."
  },
  {
    id: "ballad",
    label: "Cian",
    gender: "Male",
    accent: "Irish",
    detail: "warm and rhythmic",
    instructions: "Speak in a gentle Irish English accent with smooth rhythm and clear word endings."
  }
];

export function getPremiumVoiceOptionLabel(voice) {
  return `${voice.label} - ${voice.accent} ${voice.gender}`;
}
